import { FC } from 'react'

import PageHeading from 'components/atoms/PageHeading'
import MainTable from 'components/organisms/tables/MainTable'

import { useTableModel } from 'utils/tableModels/useGroupCourseAssignmentsTableModel'

import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import { IGroupCourse } from 'types'
import Calendar from 'components/molecules/Calendar'

interface IProps {
  groupCourse: IGroupCourse
  tabText?: string
  tabKey?: string
}

const GroupCourseLesson: FC<IProps> = ({ groupCourse }) => {
  const { t } = useTranslation()
  
  const filters = {
    group_course: groupCourse.id,
  }

  return (
    <>
      <Calendar filters={filters} loadSessions={true} />
    </>
  )
}
export default GroupCourseLesson